/* eslint-disable no-alert */
/* eslint-disable no-return-assign */
/* eslint-disable no-restricted-globals */
import styled from 'styled-components';
import { useState } from 'react';
import tmap from 'src/assets/images/user-mobile/tmap.png';
import kakaomap from 'src/assets/images/user-mobile/kakaomap.png';
import navermap from 'src/assets/images/user-mobile/navermap.png';

interface ParkingLot {
  name: string;
  distance: string;
  latitude: number;
  longitude: number;
  address: string;
  accessurl: string; // Tmap에서 사용할 URL
}

interface AccessableAppProps {
  parking: ParkingLot;
  onClose: () => void;
  festivalId: number;
}

export default function AccessableApp({
  parking,
  onClose,
  festivalId,
}: AccessableAppProps) {
  const [startY, setStartY] = useState<number | null>(null);
  const [translateY, setTranslateY] = useState(0);
  const [showToast, setShowToast] = useState(false);
  let fullAddress = '';
  if (festivalId === 7) {
    fullAddress = `충남 당진시 신평면 ${parking.address}`;
  } else if (festivalId === 9) {
    fullAddress = `부산 북구 ${parking.address}`;
  }

  const localAddress = parking.address;

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    setStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (!startY) return;
    const deltaY = e.touches[0].clientY - startY;
    if (deltaY > 0) setTranslateY(deltaY);
  };

  const handleTouchEnd = () => {
    if (translateY > 100) onClose();
    setStartY(null);
    setTranslateY(0);
  };
  const openMap = (type: 'kakaomap' | 'navermap') => {
    const lat = parking.latitude;
    const lng = parking.longitude;
    const query = encodeURIComponent(fullAddress);

    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (!isAndroid && !isIOS) {
      const webUrl =
        type === 'kakaomap'
          ? `https://map.kakao.com/?q=${query}&p=${lat},${lng}`
          : `https://map.naver.com/v5/search/${query}`;
      window.open(webUrl, '_blank');
      return;
    }

    let customScheme = '';
    let fallbackUrl = '';

    if (type === 'kakaomap') {
      customScheme = `kakaomap://route?ep=${lat},${lng}&by=CAR`;
      fallbackUrl = isIOS
        ? 'https://apps.apple.com/app/id304608425'
        : 'https://play.google.com/store/apps/details?id=net.daum.android.map';
    } else if (type === 'navermap') {
      customScheme = `nmap://route/car?dlat=${lat}&dlng=${lng}&dname=${query}`;
      fallbackUrl = isIOS
        ? 'https://apps.apple.com/app/id311867728'
        : 'https://play.google.com/store/apps/details?id=com.nhn.android.nmap';
    }

    if (isIOS) {
      const confirmed = window.confirm(
        `${type === 'kakaomap' ? '카카오맵' : '네이버맵'} 앱으로 이동하시겠어요?\n앱이 설치되어 있지 않다면 App Store로 이동됩니다.`,
      );
      if (!confirmed) return;
    }

    let hasAppOpened = false;
    const hiddenHandler = () => (hasAppOpened = true);
    document.addEventListener('visibilitychange', hiddenHandler);

    window.location.href = customScheme;

    setTimeout(() => {
      document.removeEventListener('visibilitychange', hiddenHandler);
      if (!hasAppOpened) {
        window.location.href = fallbackUrl;
      }
    }, 1500);
  };
  const openTmapDirectly = () => {
    const name = encodeURIComponent(parking.name);
    const lat = parking.latitude;
    const lng = parking.longitude;

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);

    if (!isIOS && !isAndroid) {
      alert('모바일 환경에서만 사용할 수 있습니다.');
      return;
    }

    const customScheme = isIOS
      ? `tmap://route?rGoName=${name}&rGoX=${lng}&rGoY=${lat}`
      : `tmap://route?referrer=com.skt.Tmap&goalx=${lng}&goaly=${lat}&goalname=${name}`;

    const fallbackUrl = isIOS
      ? 'https://apps.apple.com/app/id431589174'
      : 'https://play.google.com/store/apps/details?id=com.skt.tmap.ku';

    if (isIOS) {
      const confirmed = window.confirm(
        'Tmap 앱으로 이동하시겠어요?\n앱이 설치되어 있지 않다면 App Store로 이동됩니다.',
      );
      if (!confirmed) return;
    }

    let hasAppOpened = false;
    const hiddenHandler = () => (hasAppOpened = true);
    document.addEventListener('visibilitychange', hiddenHandler);

    window.location.href = customScheme;

    setTimeout(() => {
      document.removeEventListener('visibilitychange', hiddenHandler);
      if (!hasAppOpened) {
        window.location.href = fallbackUrl;
      }
    }, 1500);
  };

  // 주소 복사
  const copyAddress = () => {
    navigator.clipboard.writeText(fullAddress);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 1500);
  };

  return (
    <ModalOverlay onClick={onClose}>
      {showToast && <Toast>주소가 복사되었습니다.</Toast>}
      <ModalContainer
        style={{
          transform: `translateY(${translateY}px)`,
          transition: translateY ? 'none' : 'transform 0.3s ease-out',
        }}
        onClick={e => e.stopPropagation()}
      >
        <ModalHandle
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        />
        <OptionList>
          <Address onClick={copyAddress}>
            <ClipAddress>{localAddress}</ClipAddress>
            <CopyText>복사</CopyText>
          </Address>
          <OptionItem onClick={openTmapDirectly}>
            <img src={tmap} alt="T맵" width={20} height={20} />
            티맵으로 길찾기
          </OptionItem>
          <OptionItem onClick={() => openMap('kakaomap')}>
            <img src={kakaomap} alt="카카오맵" width={20} height={20} />
            카카오맵으로 길찾기
          </OptionItem>
          <OptionItem onClick={() => openMap('navermap')}>
            <img src={navermap} alt="네이버맵" width={20} height={20} />
            네이버맵으로 길찾기
          </OptionItem>
        </OptionList>
      </ModalContainer>
    </ModalOverlay>
  );
}

// 스타일 정의 (이전 코드 유지)
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 100;
`;

const Toast = styled.div`
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: rgba(48, 48, 48, 0.8);
  backdrop-filter: blur(2px);
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.35px;

  z-index: 999;
  animation: fadeInOut 1.5s ease;

  @keyframes fadeInOut {
    0% {
      opacity: 0;
      transform: translateX(-50%) translateY(10px);
    }
    10% {
      opacity: 0.8;
      transform: translateX(-50%) translateY(0);
    }
    90% {
      opacity: 0.8;
      transform: translateX(-50%) translateY(0);
    }
    100% {
      opacity: 0;
      transform: translateX(-50%) translateY(10px);
    }
  }
`;

const ModalContainer = styled.div`
  margin: 16px;
  width: 100%;
  height: 256px;
  max-width: 400px;
  background: linear-gradient(180deg, #f2f2f5 0%, #ededf2 100%);
  border-radius: 32px;
  text-align: center;
  position: relative;
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
`;

const ModalHandle = styled.div`
  width: 36px;
  height: 6px;
  border-radius: 24px;
  background: #909090;
  margin-top: 8px;
  margin-left: calc(50% - 20px);
`;

const OptionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const Address = styled.div`
  margin: 16px 0 14px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ClipAddress = styled.span`
  color: #505050;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.35px;
  margin-right: 4px;
  text-decoration: underline;
  text-decoration-color: #909090;
  text-underline-offset: 4px;
`;

const CopyText = styled.span`
  color: #505050;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.3px;
  padding: 2px 6px;
  border-radius: 8px;
  background: #fff;
`;

const OptionItem = styled.li`
  background: #fff;
  margin: 8px 16px;
  padding: 14px;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--Font-02_black, #111);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.4px;

  img {
    margin-right: 6px;
  }
`;
